import { DataLakeRunDataSolutionListing } from './data-lake-run-data-solution-listing';

export class DataLakeRunDataDirectory {
    public solutionListings: DataLakeRunDataSolutionListing[]

    constructor() {
        this.solutionListings = [];
    }
}
